import { ShieldOff, LogOut, Mail } from 'lucide-react';
import { useAuth } from '@/hooks/useAuth';
import Button from '@/components/common/Button';

export default function DeactivatedPage() {
  const { cmsUser, logout } = useAuth();

  return (
    <div className="min-h-screen bg-gradient-to-br from-surface-100 via-white to-surface-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md text-center">

        <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-surface-200 mb-6">
          <ShieldOff className="h-10 w-10 text-surface-500" />
        </div>

        <h1 className="text-2xl font-bold text-surface-900 mb-2">
          Account Deactivated
        </h1>

        <div className="bg-white rounded-2xl shadow-card border border-surface-200 p-6 mb-6 text-left space-y-3">
          <p className="text-surface-600 text-sm leading-relaxed">
            Your WombCat CMS account has been deactivated by an administrator.
          </p>
          <p className="text-surface-600 text-sm leading-relaxed">
            Please contact your administrator if you need your access restored.
          </p>
          {cmsUser?.email && (
            <div className="pt-2 border-t border-surface-100">
              <p className="text-xs text-surface-400">
                Account: <span className="font-medium text-surface-600">{cmsUser.email}</span>
              </p>
            </div>
          )}
        </div>

        <div className="flex flex-col gap-3">
          <Button
            variant="secondary"
            fullWidth
            leftIcon={<Mail className="h-4 w-4" />}
            onClick={() => window.location.href = 'mailto:admin@wombcat.com'}
          >
            Contact administrator
          </Button>
          <Button
            variant="ghost"
            fullWidth
            leftIcon={<LogOut className="h-4 w-4" />}
            onClick={logout}
          >
            Sign out
          </Button>
        </div>

      </div>
    </div>
  );
}
